import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { OverAskBetslipError } from '../../../../model/over-ask/over-ask';
import { BetPlacementError } from '../bet-placement-error';
import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { CleanStrategy, ErrorOrigin } from '../betslip-error';

export class OverAskError extends BetPlacementError {
    constructor(error: OverAskBetslipError, newStakeHint = 0) {
        super();
        this.origin = ErrorOrigin.BetPlacement;
        this.icon = BetPlacementErrorIcon.Warning;
        this.type = PlacementErrorType.OverAskOfferError;
        this.hasClientValidation = false;
        this.newStakeHint = newStakeHint;
        this.code = error;
        this.cleanStrategy = CleanStrategy.Manually;
    }
}
